/**
 * Created by Administrador on 10/3/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('Auth2', AuthService);

    AuthService.$inject = ['CONFIG', '$http', '$cookies', '$httpParamSerializer', '$q', 'messageService', 'User', 'Util', '$location'];

    function AuthService(CONFIG, $http, $cookies, $httpParamSerializer, $q, messageService, User, Util, $location){
        var urlBaseOauth = CONFIG.API_OAUTH + '/oauth/token';
        var safeCb = Util.safeCb;
        var currentUser = {};
        var userRoles = CONFIG.USER_ROLES || [];
        var auth = {
            login: login,
            logout: logout,
            getCurrentUser: getCurrentUser,
            isLoggedIn: isLoggedIn,
            hasRole: hasRole,
            getToken: getToken,
            destroy: destroy
        }

        if ($cookies.get('access_token') && $location.path() !== '/logout') {
            currentUser = User.get();
        }

        return auth;

        function login(credentials, callback){
            var loginData = {
                grant_type:"password",
                username: credentials.username,
                password: credentials.password,
                client_id: "client",
                scope:"read"
            };
            var encoded = btoa(CONFIG.CLIENT + ':' + CONFIG.SECRET);
            var req = {
                method: 'POST',
                url: urlBaseOauth,
                headers: {"Authorization": "Basic " + encoded, "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
                    Accept:"application/json"},
                data: $httpParamSerializer(loginData)
            }


            return  $http(req)
                .then(function(response){
                    var expireDate = new Date (new Date().getTime() + (1000 * response.data.expires_in));
                    $cookies.put("access_token", response.data.access_token, {'expires': expireDate});
                    $cookies.put("refresh", response.data.refresh_token, {'expires': expireDate});
                    $cookies.put("expires", expireDate);
                    currentUser = User.get();
                    return currentUser.$promise;
                })
                .then(function(user){
                    safeCb(callback)(null, user);
                    return user;
                })
                .catch(function(error){
                    auth.logout();
                    messageService.loginError();
                    safeCb(callback)(error.data);
                    return $q.reject(error.data);
                });
        }

        function logout(cb){

            var req = {
                method: 'POST',
                url: CONFIG.API_OAUTH + "/api/logout-up"
            }

            $http(req).then(function(){
                $cookies.remove("access_token");
                $cookies.remove("refresh_token");
                currentUser = {};
                delete $http.defaults.headers.common["Authorization"];
                delete $http.defaults.headers.common["access"];
                delete $http.defaults.headers.common["refresh"];
                cb();
            });
        }

        function isLoggedIn(callback){
            if (arguments.length === 0) {
                return currentUser.hasOwnProperty('role');
            }

            return auth.getCurrentUser(null)
                .then(function(user) {
                    var is = user.hasOwnProperty('role');
                    safeCb(callback)(is);
                return is;
            });
        }

        function getCurrentUser(callback){
            if (arguments.length === 0) {
                return currentUser;
            }

            var value = currentUser.hasOwnProperty('$promise') ? currentUser.$promise : currentUser;
            return $q.when(value)
                .then(function(user){
                    safeCb(callback)(user);
                    return user;
                }, function() {
                    safeCb(callback)({});
                    return {};
                });
        }

        function hasRole(role, callback){
            var hasRole = function(r, h){
                return userRoles.indexOf(r) >= userRoles.indexOf(h);
            }

            if (arguments.length < 2) {
                return hasRole(currentUser.role, role);
            }

            return auth.getCurrentUser(null)
                .then(function(user){
                    var has = user.hasOwnProperty('role') ? hasRole(user.role, role) : false;
                    safeCb(callback)(has);
                    return has;
                })
        }

        function getToken(){
            return $cookies.get('access_token');
        }

        function destroy() {
            $cookies.remove("access_token");
            $cookies.remove("refresh");
            $cookies.remove("expires_in");
            currentUser = {};
            delete $http.defaults.headers.common["Authorization"];
            delete $http.defaults.headers.common["access"];
            delete $http.defaults.headers.common["refresh"];
        }
    }
})();
